import { render } from "./VerifyFormComponent.vue?vue&type=template&id=398590f3&scoped=true"
import script from "./VerifyFormComponent.vue?vue&type=script&lang=js"
export * from "./VerifyFormComponent.vue?vue&type=script&lang=js"

import "./VerifyFormComponent.vue?vue&type=style&index=0&id=398590f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398590f3"]])

export default __exports__